<script>
    export let infos;
    export let y;
    export let x;
    let test = 58;
</script>

<div style="top:{y - 40}px;left:{x + 45}px">
    <img src="img/fondinfobulle.png" alt="infobulle" />
    <p>
        {infos}
    </p>
</div>

<style>
    div {
        background-color: rgba(216, 131, 20, 0.253);
        width: 210px;
        height: 200px;
        position: absolute;
        float: left;
        border-radius: 15px;
        box-shadow: 0px 0px 10px rgb(0, 0, 0) inset;
        border: solid 1px red;
        box-shadow: 0px 0px 10px rgb(0, 0, 0);
        /* top: 90%;
        left: 50%;
        transform: translate(-50%, -50%); */
        z-index: 5;
        color: rgb(0, 247, 255);
        text-shadow: 1px 1px 6px rgb(0, 0, 0);
    }
    img {
        opacity: 1;
        position: absolute;
    }
</style>
